import { CertidaoNegativaAPI } from "@/api/financeiro/certidao-negativa.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";


const api = new CertidaoNegativaAPI();

const findByCpfCnpj = (token: string, cpfCnpj: string): AxiosObservable<any> => {
  return api.findByTokenAndCpfCnpj(token, cpfCnpj);
};

const generatePdf = (recaptcha: string, cpfCnpj: string): AxiosObservable<any> => {
  return api.generatePdf(recaptcha, cpfCnpj);
};

export default {
  findByCpfCnpj,
  generatePdf
};
